var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3811_4217)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.5 1H4.5C2 1 1 2 1 4.5V7.5C1 10 2 11 4.5 11H7.5C10 11 11 10 11 7.5V6.5",
    stroke: "black",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.02092 1.50964L4.08092 5.44964C3.93092 5.59964 3.78092 5.89464 3.75092 6.10964L3.53592 7.61464C3.45592 8.15964 3.84092 8.53964 4.38592 8.46464L5.89092 8.24964C6.10092 8.21964 6.39592 8.06964 6.55092 7.91964L10.4909 3.97964C11.1709 3.29964 11.4909 2.50964 10.4909 1.50964C9.49092 0.509638 8.70092 0.829638 8.02092 1.50964Z",
    stroke: "black",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.45508 2.0752C7.62087 2.66393 7.93507 3.20023 8.36756 3.63272C8.80005 4.06521 9.33634 4.3794 9.92508 4.5452",
    stroke: "black",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3811_4217"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.53d9db6b5ea451007dcb34ea9239f9ab.svg";
export { ForwardRef as ReactComponent };